module.exports = __webpack_public_path__ + "static/media/logoeyespot.429ec565.png";